var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampaignSnapshotIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "24px",
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CF75E507-9E15-4E4E-8CBC-CC83C36C3F99") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBlue---Milestone-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "13.0_My-Library_02",
    transform: "translate(-1224.000000, -604.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pop-Up-Actions-Copy",
    transform: "translate(1215.000000, 591.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Remove-Copy",
    transform: "translate(9.210526, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Left",
    transform: "translate(0.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66661071,1 C5.17350768,1 5.58338929,1.41072084 5.58338929,1.91661071 L5.58338929,1.91661071 L5.58338929,3.75 L17.5,3.75 C19.016159,3.75 20.25,4.98384095 20.25,6.5 L20.25,6.5 L20.25,18.4166107 L22.0833893,18.4166107 C22.5902863,18.4166107 23,18.8273315 23,19.3333893 C23,19.8392792 22.5902863,20.25 22.0833893,20.25 L22.0833893,20.25 L20.25,20.25 L20.25,22.0833893 C20.25,22.5892792 19.8402863,23 19.3333893,23 C18.8264923,23 18.4166107,22.5892792 18.4166107,22.0833893 L18.4166107,22.0833893 L18.4166107,20.25 L6.5,20.25 C4.98384095,20.25 3.75,19.016159 3.75,17.5 L3.75,17.5 L3.75,5.58338929 L1.91661071,5.58338929 C1.40971373,5.58338929 1,5.17266846 1,4.66661071 C1,4.16072084 1.40971373,3.75 1.91661071,3.75 L1.91661071,3.75 L3.75,3.75 L3.75,1.91661071 C3.75,1.41072084 4.15971373,1 4.66661071,1 Z M17.5,5.58338929 L5.58338929,5.58338929 L5.58338929,14.6941071 L6.27995299,13.9983825 C6.8850403,13.3924561 7.94834899,13.3924561 8.55326842,13.9983825 L8.55326842,13.9983825 L9.70838929,15.1533356 L14.0717316,10.7899933 C14.676651,10.1840668 15.7399597,10.1840668 16.345047,10.7899933 L16.345047,10.7899933 L18.4166107,12.8617249 L18.4166107,6.5 C18.4166107,5.99494935 18.0060577,5.58338929 17.5,5.58338929 L17.5,5.58338929 Z M9.25,7.41661071 C10.2624512,7.41661071 11.0833893,8.23754883 11.0833893,9.25 C11.0833893,10.2624512 10.2624512,11.0833893 9.25,11.0833893 C8.23754883,11.0833893 7.41661071,10.2624512 7.41661071,9.25 C7.41661071,8.23754883 8.23754883,7.41661071 9.25,7.41661071 Z",
    id: "Combined-Shape",
    fill: "currentColor"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignSnapshotIcon);
export default __webpack_public_path__ + "static/media/CampaignSnapshotIcon.ceb0bfcbad90e34b206d79e252832577.svg";
export { ForwardRef as ReactComponent };